import {
  Alert,
  Button,
  FormControlLabel,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useState } from 'react'
import DetailsBox from '../../../components/Cards/DetailsBox'
import API from '../../../services/API'
import { GlobalContext } from '../../../App'

const EditReferee = ({
  existingReferee,
  selectedMenuReference,
  applicationID,
  onClose,
  addManualResponse,
}) => {
  const [fullName, setFullName] = useState(existingReferee?.fullName ?? '')
  const [relationship, setRelationship] = useState(
    existingReferee?.relationship ?? '',
  )
  const [company, setCompany] = useState(existingReferee?.company ?? '')
  const [position, setPosition] = useState(existingReferee?.position ?? '')
  const [email, setEmail] = useState(existingReferee?.email ?? '')
  const [duration, setDuration] = useState(existingReferee?.duration ?? '')
  const [phoneNumber, setPhoneNumber] = useState(
    existingReferee?.phoneNumber ?? '',
  )
  const [comments, setComments] = useState(existingReferee?.comments ?? '')
  const [manualResponse, setManualResponse] = useState(
    addManualResponse ?? false,
  )
  const [response, setResponse] = useState(null)
  const [selectedFile, setSelectedFile] = useState(null)

  const { setToast } = useContext(GlobalContext)

  let s3url
  let s3key

  const handleSubmit = async () => {
    const sendToDb = async ({ s3key }) => {
      await API.post('/update-employees-application', {
        applicationID,
        [`reference${selectedMenuReference}`]: {
          fullName,
          relationship,
          company,
          position,
          email,
          phoneNumber,
          duration,
          comments,
          response: !response
            ? null
            : { ...response, ...(s3key && { document: s3key }) },
          emailSend: true,
        },
        referenceUpdated: selectedMenuReference,
      }).then((res) => {
        if (res.status === 200) {
          onClose()
          setToast({
            severity: 'info',
            message:
              'Referee Updated. An email has not been automatically sent.',
          })
        }
      })
    }

    if (selectedFile) {
      await API.post('gets3uploadUrl', {
        folder: 'employees/applications/referenceresponses',
        extension: selectedFile.type.split('/')[1],
      })
        .then((res) => {
          s3url = res.data.url
          s3key = res.data.key
          API.put(s3url, selectedFile, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then(() => {
            setResponse((prev) => ({ ...prev, document: s3key }))
            sendToDb({ s3key })
          })
        })
        .catch((e) => console.log(e))
    } else {
      sendToDb({ s3key })
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="title2">
          Edit Referee {selectedMenuReference}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Alert severity="warning">
          Please be aware that any existing reference links will remain valid
          until a reference has been received.
        </Alert>
      </Grid>
      <Grid item xs={12} container spacing={2}>
        {[
          { label: 'Full Name', value: fullName, changer: setFullName },
          {
            label: 'Relationship to you',
            value: relationship,
            changer: setRelationship,
            helperText: 'e.g. previous employer, colleague',
          },
          { label: 'Company', value: company, changer: setCompany },
          {
            label: 'Their Position / Role',
            value: position,
            changer: setPosition,
          },
          { label: 'Email', value: email, changer: setEmail },
          {
            label: 'Duration of Relationship',
            value: duration,
            changer: setDuration,
          },
          {
            label: 'Phone Number',
            value: phoneNumber,
            changer: setPhoneNumber,
          },
          {
            label: 'Comments',
            value: comments,
            changer: setComments,
            helperText: 'Optional field for any additional information',
          },
        ].map(({ label, value, changer, helperText }, index) => (
          <Grid item xs={12} lg={6} key={index}>
            <TextField
              key={label}
              value={value}
              fullWidth
              autoComplete="none"
              onChange={(e) => changer(e.target.value)}
              multiline={value === 'comments'}
              minRows={value === 'comments' ? 2 : 1}
              label={label}
              helperText={helperText}
            />
          </Grid>
        ))}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={manualResponse}
                onChange={(e) => setManualResponse(e.target.checked)}
                color="success"
              />
            }
            label="Manually add a response"
          />
          {manualResponse && (
            <Stack>
              <Typography variant="title3">Response</Typography>
              <TextField
                value={response?.comments ?? ''}
                minRows={2}
                placeholder="Comments"
                onChange={(e) =>
                  setResponse((prev) => ({ ...prev, comments: e.target.value }))
                }
              />
              <TextField
                type="file"
                size="small"
                defaultValue={selectedFile}
                inputProps={{ accept: ['application/pdf', '.doc', '.docx'] }}
                onChange={(e) => setSelectedFile(e.target.files[0])}
                required
              />
            </Stack>
          )}
        </Grid>
        <Grid item xs={12}>
          <Button
            fullWidth
            color="success"
            onClick={handleSubmit}
            variant="contained"
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default EditReferee
